import React from 'react';
import './ActionButton.css';

function ActionButton(props) {
    const handleClick = (event) => {
        props.onClickButton();
        event.preventDefault();
    };

    return (
            <button className="ActionButton" onClick={handleClick}>
                {props.buttonMsg}
            </button>
    );
}

export default ActionButton;



// WEBPACK FOOTER //
// ./src/components/ActionButton/ActionButton.js